
<template>
  <div>
    <!-- b-table -->
    <b-skeleton-table
      v-if="is_loading"
      :rows="9"
      :columns="10"
      :table-props="{ bordered: true, striped: true }"
    ></b-skeleton-table>
    <div>
      <div class="d-flex">
        <GenericButtonDownload
          v-if="!is_loading && grade_group_report"
          :tooltip_text="$t('toolbar.reports.reportXlsx')"
          :click_button="DownloadExcel"
          :class="`ml-auto mr-0`"
          :disabled_button="disabled_button_excel"
          :icon_excel="true"
        ></GenericButtonDownload>
      </div>
      <b-table-simple
        bordered
        no-border-collapse
        small
        responsive
        sticky-header="80vh"
        v-if="!is_loading && grade_group_report"
      >
        <b-thead>
          <b-tr>
            <b-th
              class="text-center align-middle primary-header"
              :colspan="6 + grade_group_report.plan_levels.length"
            >
              <div class="d-flex align-items-center justify-content-between">
                <span class="text-center mx-auto">
                  {{
                    $getVisibleNames(
                      "manual.reporte.average_grades",
                      false,
                      $t("toolbar.reports.averagesByMatterTitle", {
                        matter: $getVisibleNames(
                          "mesh.egressprofilematter",
                          false,
                          "Asignatura"
                        ),
                        egressProfile: $getVisibleNames(
                          "mesh.egressprofile",
                          false,
                          "Perfil de Egreso"
                        ),
                      })
                    ).toUpperCase()
                  }}
                </span>
              </div>
            </b-th>
          </b-tr>
          <b-tr>
            <b-th class="text-center align-middle secondary-header">{{
              $t("toolbar.reports.number")
            }}</b-th>
            <b-th class="text-center align-middle secondary-header">{{
              $t("toolbar.reports.lastName").toUpperCase()
            }}</b-th>
            <b-th class="text-center align-middle secondary-header">{{
              $t("toolbar.reports.firstName").toUpperCase()
            }}</b-th>
            <b-th class="text-center align-middle secondary-header">{{
              $t("reusable.common.rut").toUpperCase()
            }}</b-th>
            <b-th class="text-center align-middle secondary-header">{{
              $t("toolbar.reports.cohort").toUpperCase()
            }}</b-th>
            <b-th class="text-center align-middle secondary-header">{{
              $t("toolbar.reports.regime").toUpperCase()
            }}</b-th>
            <b-th
              v-for="levels in grade_group_report.plan_levels"
              :key="`header-level-${levels.readable_name}`"
              class="text-center align-middle secondary-header"
            >
              <div class="d-flex justify-content-center">
                {{ levels.readable_name }}
                <InfoPopover
                  :id_popover="`header-level-${levels.plan_level}`"
                  class="ml-2"
                >
                  <template #title>{{
                    $getVisibleNames(
                      "mesh.egressprofilematter",
                      true,
                      "Asignaturas"
                    ).toUpperCase()
                  }}</template>
                  <!-- body -->
                  <template>
                    <div class="visible_columns">
                      <div
                        v-for="matter in levels.matters"
                        :key="`b-popover-body-${levels.plan_level}-${matter.id}`"
                      >
                        <!-- <template v-if="matter.code.length > 0">
                          <strong>{{ matter.code }} </strong>-
                        </template> -->
                        {{ matter.name }}
                      </div>
                    </div>
                  </template>
                </InfoPopover>
              </div>
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="evaluatee in grade_group_report.evaluatees"
            :key="`evaluatee-${evaluatee.id}`"
          >
            <b-td>{{ evaluatee.idx }}</b-td>
            <b-td class="text-left">{{ evaluatee.last_name }}</b-td>
            <b-td class="text-left">{{ evaluatee.first_name }}</b-td>
            <b-td>{{ evaluatee.identifier }}</b-td>
            <b-td>
              <span
                v-b-tooltip.hover="
                  `${$t('toolbar.reports.declaredCohort')}: ${evaluatee.declared_cohort}`
                "
                >{{ evaluatee.cohort }}</span
              >
            </b-td>
            <b-td>
              <RegimeExplanationBadge
                :evaluatee_id="evaluatee.id"
                :is_on_track="evaluatee.evaluatee_is_on_track"
                :label="regimeLabel(evaluatee.evaluatee_is_on_track)"
              ></RegimeExplanationBadge>
            </b-td>
            <template v-for="level in grade_group_report.plan_levels">
              <template
                v-for="evaluatee_plan_level in evaluatee.plan_levels.filter(
                  (x) => x.plan_level == level.plan_level
                )"
              >
                <b-td
                  :key="`evaluatee-${evaluatee.id}-level-${level.plan_level}-plan_level-${evaluatee_plan_level.plan_level}`"
                  :style="`background-color:${evaluatee_plan_level.grade_color} !important`"
                >
                  <div
                    :id="`popover-evaluatee-${evaluatee.id}-level-${level.plan_level}-plan_level-${evaluatee_plan_level.plan_level}`"
                    class="popover-icon"
                  >
                    <span v-if="evaluatee_plan_level.average_grade == '-'">
                      -
                    </span>
                    <span v-else>
                      {{ evaluatee_plan_level.average_grade | Round }}
                    </span>
                    <b-popover
                      :target="`popover-evaluatee-${evaluatee.id}-level-${level.plan_level}-plan_level-${evaluatee_plan_level.plan_level}`"
                      triggers="hover"
                      placement="top"
                      boundary="viewport"
                    >
                      <template #title>{{
                        $getVisibleNames(
                          "mesh.egressprofilematter",
                          true,
                          "Asignaturas"
                        ).toUpperCase()
                      }}</template>
                      <!-- body -->
                      <template>
                        <div class="visible_columns">
                          <RenderVHtml
                            v-for="student_result in evaluatee_plan_level.student_results"
                            :key="`b-popover-body-${level.plan_level}-${student_result.id}`"
                            class="p-0"
                            :content="
                              getMatterLabel(student_result, level.plan_level)
                            "
                          ></RenderVHtml>
                        </div>
                      </template>
                    </b-popover>
                  </div>
                </b-td>
              </template>
            </template>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <b-table-simple
        bordered
        small
        responsive
        v-if="grade_group_report && grade_group_report.grade_ranges"
        class="table-assesment-range-table"
      >
        <b-thead>
          <b-tr>
            <b-th class="primary-header" colspan="2">{{
              $t("toolbar.reports.gradeRanges").toUpperCase()
            }}</b-th>
          </b-tr>
          <b-tr>
            <b-th class="secondary-header">{{
              $t("toolbar.reports.name").toUpperCase()
            }}</b-th>
            <b-th class="secondary-header range-column">{{
              $t("toolbar.reports.rangePercentage").toUpperCase()
            }}</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="grade_range in grade_group_report.grade_ranges"
            :key="`row-${grade_range.id}`"
          >
            <b-td class="text-center aling-middle">{{ grade_range.name }}</b-td>
            <b-td
              class="text-center aling-middle"
              :style="`background-color:${grade_range.color} !important`"
            >
              <div>
                {{ grade_range.start_grade }}
                <span v-if="grade_range.include_start_grade">&le;</span>
                <span v-else>&lt;</span>
                x
                <span v-if="grade_range.include_finish_grade">&le;</span>
                <span v-else>&lt;</span>
                {{ grade_range.finish_grade }}
              </div>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <!-- Grafico -->
      <GenericGraphic
        v-if="planLevelOptions.length > 0"
        :labels="chartLabels"
        :datasets="chartDatasets"
        :legend_labels="legendLabels"
        :title_graphic="
          $t('toolbar.reports.averageGradesByEgressProfileTitle', {
            egressProfile: $getVisibleNames(
              'mesh.egressprofile',
              false,
              'Perfil de Egreso'
            ),
          }).toUpperCase()
        "
        :total_students="totalStudents"
        :label_y_axis="$t('toolbar.reports.numberOfStudents')"
        :title_table_circular="$t('toolbar.reports.assessment')"
        :selected_assessment="selected_assessment"
      >
        <template #selector>
          <div class="d-flex">
            <b-form-select
              v-model="selected_assessment"
              :options="planLevelOptions"
              @change="updatePlanLevel"
              class="select-level"
            ></b-form-select>
          </div>
        </template>
      </GenericGraphic>
    </div>
  </div>
</template>

<script>
// import * as names from "@/store/names";
// import { mapGetters } from "vuex";
import {
  showLoadingAlert,
  downloadFileFromResponse,
  EventBus,
} from "@/utils/utils";

export default {
  name: "EvaluationGradeReportTable",
  components: {
    InfoPopover: () => import("@/components/reusable/InfoPopover"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    GenericButtonDownload: () =>
      import("@/components/reusable/Buttons/GenericButtonDownload"),
    GenericGraphic: () => import("@/components/reusable/GenericGraphic"),
    RegimeExplanationBadge: () =>
      import("@/components/reports/TeachingReport/RegimeExplanationBadge"),
  },
  props: {
    egress_profile: {
      type: Object,
      required: true,
    },
    cohorts_: {
      type: Array,
      required: true,
    },
    cohort_indices_: {
      type: Array,
      default: () => [],
    },
    campuses_: {
      type: Array,
    },
    student_status_: {
      type: Array,
      default: () => [],
    },
    grade_range_group: {
      type: [Number, null],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      is_loading: false,
      disabled_button_excel: false,
      grade_group_report: null,
      selected_assessment: "compare_all", // Variable para guardar assessment del selector.
    };
  },
  computed: {
    isOnTrack() {
      const student_status_ids = this.student_status_.map((x) => x.id);
      if (student_status_ids.includes(1) && student_status_ids.includes(2))
        return null;
      else if (student_status_ids.includes(1)) return true;
      else if (student_status_ids.includes(2)) return false;
      return null;
    },
    planLevelOptions() {
      if (!this.grade_group_report?.plan_levels) return [];

      const options = [];

      options.push({
        value: "compare_all",
        text: this.$t("toolbar.reports.viewAllLevels"),
      });

      this.grade_group_report.plan_levels.map((x) => {
        options.push({
          value: x.plan_level,
          text: x.readable_name,
        });
      });

      return options;
    },
    totalStudents() {
      return this.grade_group_report?.evaluatees?.length || 0;
    },
    chartLabels() {
      if (!this.grade_group_report?.plan_levels) {
        return [];
      }
      // Para la opción Grupal
      if (this.selected_assessment == "compare_all") {
        return this.grade_group_report.plan_levels.map((x) => x.readable_name);
      }
      // Para la opción individual
      const level = this.grade_group_report.plan_levels.find(
        (x) => x.plan_level == this.selected_assessment
      );

      if (!level) return [];
      return level.matters.map((x) => x.name);
    },
    chartDatasets() {
      if (
        !this.grade_group_report?.grade_ranges ||
        !this.grade_group_report?.evaluatees ||
        !this.selected_assessment
      ) {
        return [];
      }

      const datasets = [];

      // Si se selecciona "Comparar todos"
      if (this.selected_assessment == "compare_all") {
        // Crear un dataset por cada grade_ranges
        this.grade_group_report.grade_ranges.forEach((range) => {
          const data = this.grade_group_report.plan_levels.map((level) => {
            let count = 0;

            this.grade_group_report.evaluatees.forEach((student) => {
              const levelResult = student.plan_levels.find(
                (x) => x.plan_level == level.plan_level
              );

              if (levelResult && levelResult.average_grade !== null) {
                const grade = levelResult.average_grade;

                const inRange =
                  (range.include_start_grade
                    ? grade >= range.start_grade
                    : grade > range.start_grade) &&
                  (range.include_finish_grade
                    ? grade <= range.finish_grade
                    : grade < range.finish_grade);

                if (inRange) {
                  count++;
                }
              }
            });

            return count;
          });

          datasets.push({
            label: range.name, // Nombre del rango
            data: data, // Datos para el gráfico
            backgroundColor: range.color,
          });
        });
      } else {
        // Si se selecciona una opción individual
        const level = this.grade_group_report.plan_levels.find(
          (x) => x.plan_level == this.selected_assessment
        );

        if (!level) return [];

        // Crear un dataset por cada grade_ranges segun el nivel seleccionado
        this.grade_group_report.grade_ranges.forEach((range) => {
          const data = level.matters.map((matter) => {
            let count = 0;

            this.grade_group_report.evaluatees.forEach((student) => {
              const levelResult = student.plan_levels.find(
                (x) => x.plan_level == level.plan_level
              );

              if (levelResult) {
                const result = levelResult.student_results.find(
                  (x) => x.id == matter.id
                );

                if (result && result.grade != null) {
                  const grade = result.grade;

                  const inRange =
                    (range.include_start_grade
                      ? grade >= range.start_grade
                      : grade > range.start_grade) &&
                    (range.include_finish_grade
                      ? grade <= range.finish_grade
                      : grade < range.finish_grade);

                  if (inRange) {
                    count++;
                  }
                }
              }
            });

            return count;
          });

          datasets.push({
            label: range.name,
            data: data,
            backgroundColor: range.color,
          });
        });
      }

      return datasets;
    },

    legendLabels() {
      if (this.grade_group_report?.grade_ranges) {
        return this.grade_group_report.grade_ranges.map((x) => ({
          label: x.name,
          color: x.color,
        }));
      }
      return [];
    },
  },
  methods: {
    updatePlanLevel(selectedId) {
      this.selected_assessment = selectedId;
    },
    regimeLabel(isOnTrack) {
      if (isOnTrack === true) return this.$t("toolbar.reports.inRegime");
      if (isOnTrack === false) return this.$t("toolbar.reports.notInRegime");
      return "-";
    },
    DownloadExcel() {
      this.disabled_button_excel = true;
      showLoadingAlert(
        this.$t("reusable.common.generatingExcel"),
        this.$t("reusable.common.pleaseWaitFile")
      );
      this.$restful
        .Post(
          `/evaluations2/excel_individual_plan_level_grades/`,
          {
            egress_profile: this.egress_profile.id,
            cohort_year_filter_ids: this.cohorts_.map((x) => x.cohort),
            cohort_index_filter_ids: this.cohort_indices_.map(
              (x) => x.cohort_index
            ),
            grade_range_group: this.grade_range_group,
            is_on_track: this.isOnTrack,
          },
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.$swal.close();
          if (response) {
            downloadFileFromResponse(
              response,
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              () => {
                this.disabled_button_excel = false;
              },
              () => {
                this.disabled_button_excel = false;
                this.$swal.fire(
                  this.$t("reusable.common.error"),
                  this.$t("reusable.common.downloadError"),
                  "error"
                );
              }
            );
          } else {
            this.disabled_button_excel = false;
            this.$swal.fire(
              this.$t("reusable.common.error"),
              this.$t("reusable.common.generateError"),
              "error"
            );
          }
        })
        .catch(() => {
          this.disabled_button_excel = false;
          this.$swal.close();
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
    getMatterLabel(student_result, plan_level) {
      if (!this.grade_group_report) return "-";
      const level = this.grade_group_report.plan_levels.find(
        (x) => x.plan_level == plan_level
      );
      if (level) {
        const matter = level.matters.find((x) => x.id == student_result.id);
        if (matter) {
          const grade =
            student_result.grade == "-"
              ? "-"
              : this.$round(student_result.grade);
          return `${matter.name}: <strong>${grade}</strong>`;
        }
      }
      return "-";
    },
    getGradeRange() {
      this.is_loading = true;
      this.$restful
        .Post(`/evaluations2/individual_plan_level_grades/`, {
          egress_profile: this.egress_profile.id,
          cohort_year_filter_ids: this.cohorts_.map((x) => x.cohort),
          cohort_index_filter_ids: this.cohort_indices_.map(
            (x) => x.cohort_index
          ),
          grade_range_group: this.grade_range_group,
          is_on_track: this.isOnTrack,
        })
        .then((response) => {
          this.grade_group_report = response;
          this.$swal.close();
          EventBus.$emit("report_request_finished");
          this.is_loading = false;
        })
        .catch(() => {
          this.is_loading = false;
          this.$swal.close();
          EventBus.$emit("report_request_finished");
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
  },
  created() {
    this.getGradeRange();
  },
};
</script>

<style scoped>
.select-period {
  width: auto;
}
.primary-header {
  background-color: var(--kl-color-accent-medium) !important;
  color: white !important;
}
.secondary-header {
  background: var(--kl-table-header-bg) !important;
  color: var(--kl-table-header-text);
}
.visible_columns {
  max-height: 300px;
  overflow: auto;
}
.popover-icon {
  cursor: pointer;
}

@media print {
  .table-b-table-default {
    max-height: none !important;
    overflow: visible !important;
  }
}
</style>

